export default {
  nav: {
    apartments: "Apartments",
    manifesto: "Manifest",
    map: "Karte",
    contact: "Kontakt",
    book: "Buchen",
    menu: "Menü",
  },
  lang: { es: "Español", en: "English", fr: "Français", de: "Deutsch" },
  hero: {
    kicker: "Zeitmiete in der Stadt Cádiz",
    line1: "Luz de Cádiz",
    line2: "Apartments",
    sub: "Vier Wohnungen, perfekt für Gruppen bis zu 8 Personen, an der Playa Victoria oder in der Altstadt. Direkt buchen, ohne Gebühren.",
    cta1: "Apartments ansehen",
    badge: "Telearbeit & Aufenthalte über 1 Monat: Sonderkonditionen",
    scroll: "Scrollen",
  },
  manifesto: {
    kicker: "Manifest",
    chapters: [
      { n: "01", title: "Das Licht", text: "Cádiz hat ein Licht, das es sonst nirgendwo gibt: Es fällt seitlich ein, weiß, und macht alles klar. Unsere Häuser sind gebaut, um es hereinzulassen." },
      { n: "02", title: "Das Salz", text: "Der Atlantik ist in jeder Straße zu spüren. La Caleta, La Cortadura, die Strandpromenade: Das Meer ist nie mehr als zehn Minuten von Ihrer Tür entfernt." },
      { n: "03", title: "Der Kalk", text: "Weiß getünchte Patios, handbemalte Azulejos, Austernstein. Vier lichtdurchflutete Häuser, jedes mit seinem Viertel und Charakter." },
    ],
  },
  gallery: {
    kicker: "Die Kollektion",
    title: "Vier Häuser, ein Ozean",
    sub: "Von der Altstadt bis La Cortadura: Wählen Sie Ihr Cádiz.",
    guests: "Gäste",
    bedrooms: "Schlafz.",
    from: "ab",
    night: "Nacht",
    view: "Apartment ansehen",
  },
  marquee: { items: ["Meersalz", "Sonnenuntergänge", "Türkiser Atlantik", "Pescaíto frito", "Austernstein"] },
  map: {
    kicker: "Die Karte",
    title: "Übernachten in Cádiz",
    sub: "Vier handverlesene Lagen, von der Altstadt bis zum Strand.",
    view: "Apartment ansehen",
  },
  contact: {
    kicker: "Kontakt",
    title: "Sprechen wir",
    sub: "Sagen Sie uns, was Sie suchen – wir antworten innerhalb von 24 Stunden. Oder schreiben Sie uns direkt auf WhatsApp.",
    name: "Name",
    email: "E-Mail",
    phone: "Telefon (optional)",
    message: "Nachricht",
    send: "Nachricht senden",
    whatsapp: "Per WhatsApp senden",
    success: "Nachricht gesendet. Wir antworten innerhalb von 24 h.",
    error: "Senden fehlgeschlagen. Bitte erneut versuchen oder per WhatsApp schreiben.",
    response: "Antwort in unter 24 h",
  },
  footer: {
    tagline: "Vier Apartments in der Stadt Cádiz: Playa Victoria und Altstadt.",
    rights: "Alle Rechte vorbehalten.",
    seo: "Zeitmiete in Cádiz · Temporäre Apartments in Cádiz Stadt · Mietwohnungen auf Zeit an der Playa Victoria und in der Altstadt · Remote Work & Telearbeit am Meer · Aufenthalte über einen Monat mit Sonderangeboten",
  },
  detail: {
    from: "ab",
    perNight: "/ Nacht",
    guests: "Gäste",
    bedrooms: "Schlafzimmer",
    baths: "Bäder",
    area: "m²",
    house: "Das Haus",
    amenities: "Ausstattung",
    district: "Das Viertel",
    where: "Wo es liegt",
    openMaps: "In Google Maps öffnen",
    back: "Zurück zur Kollektion",
    notFound: "Apartment nicht gefunden",
    longstayBadge: "Telearbeiter · Aufenthalte über 1 Monat · Sonderangebote — Preise & Konditionen anfragen",
    mapBlocked: "Sie haben Drittanbieter-Cookies abgelehnt, daher wird die Google-Karte hier nicht geladen. Sie können den Standort direkt in Google Maps öffnen:",
  },
  booking: {
    title: "Ihren Aufenthalt buchen",
    checkin: "Anreise",
    checkout: "Abreise",
    nights: "Nächte",
    night: "Nacht",
    total: "Gesamt",
    taxes: "Steuern werden beim Bezahlen berechnet",
    cta: "Buchen & bezahlen",
    whatsapp: "Per WhatsApp anfragen",
    name: "Vollständiger Name",
    email: "E-Mail",
    phone: "Telefon",
    errDates: "Wählen Sie An- und Abreisedatum",
    errFields: "Bitte Name, E-Mail und Telefon ausfüllen",
    errConflict: "Diese Daten wurden gerade belegt. Bitte andere wählen.",
    errGeneric: "Zahlung konnte nicht gestartet werden. Bitte erneut versuchen.",
    secure: "Sichere Zahlung mit Stripe · Sofortige Bestätigung",
    legendFree: "Verfügbar",
    legendBusy: "Belegt",
    loading: "Weiterleitung zur Zahlung…",
    dogs: "Hunde",
    cribs: "Baby (Kinderbett)",
    cleaning: "Endreinigung",
    linen: "Bettwäsche & Handtücher",
    petsFee: "Haustiere",
    discountLine: "Langzeit-Rabatt (−{{pct}}%)",
    consult: "Für Aufenthalte über einen Monat haben wir Sonderangebote: fragen Sie uns per WhatsApp",
    rateTitle: "Wählen Sie Ihren Tarif",
    rateFlex: "Flexibler Tarif",
    rateStd: "Standardtarif",
    rateFlexPolicy: "Erste 24 h kostenlos · Bis 15 Tage vor Anreise: 90% Erstattung (abzüglich Anzahlung) · 14 bis 7 Tage vorher: 50% · Ab 6 Tagen vorher: keine Erstattung",
    rateStdPolicy: "15% Rabatt auf die Unterkunft · Nach den ersten 24 h nicht erstattungsfähig",
    depositNote: "Buchungsanzahlung: {{amount}} bei keinem Tarif erstattungsfähig, sobald 24 h seit der Buchung vergangen sind.",
    datesTitle: "Daten ändern",
    nonrefLine: "Nicht erstattungsfähiger Tarif (−15% Unterkunft)",
    linenOptional: "optional",
    extrasNote: "Babybetten & Hochstühle kostenlos auf Anfrage · Hundebetten & -näpfe kostenlos auf Anfrage",
    helpEmailSubject: "Erstattungsanfrage · {{apartment}}",
    errSummer: "Im Juli und August beträgt der Mindestaufenthalt 4 Nächte (Sie haben {{nights}})",
    errWeekend: "Freitag- und Samstagnächte müssen zusammen gebucht werden",
    altTitle: "Diese Wohnung ist an diesen Daten nicht frei. Diese sind verfügbar:",
    altDatesTitle: "Gleiche Wohnung, alternative Daten (gleiche Nächte):",
    altNone: "Keine andere Wohnung ist an diesen Daten frei: schreiben Sie uns per WhatsApp.",
    openNote: "Vorerst sind Online-Buchungen für Juli und August möglich. Für andere Zeiträume schreiben Sie uns per WhatsApp.",
    closed: "Die gewünschten Daten sind ausgebucht. Bitte kontaktieren Sie {{email}} für weitere Informationen.",
    errOpenMonths: "Vorerst können online nur Daten im Juli und August gebucht werden",
    payTitle: "Zahlungsmethode",
    pay_card: "Karte · Apple/Google Pay",
    pay_paypal: "PayPal",
    pay_bizum: "Bizum",
    feeService: "Zahlungsbearbeitungsgebühr (1%)",
    codePlaceholder: "Haben Sie einen Rabattcode?",
    codeApply: "Anwenden",
    codeOk: "Code angewendet: −{{pct}}%",
    codeInvalid: "Ungültiger Code",
    codeApplied: "Code {{code}} (−{{pct}}%) angewendet",
    codeRemove: "Entfernen",
    codeLine: "Code {{code}} (−{{pct}}%)",
  },
  success: {
    checking: "Ihre Buchung wird bestätigt…",
    title: "Buchung bestätigt",
    sub: "Wir haben Ihnen die Details per E-Mail geschickt. Bis bald in Cádiz.",
    entry: "Anreise",
    exit: "Abreise",
    nights: "Nächte",
    total: "Gesamt",
    whatsapp: "Per WhatsApp Bescheid sagen",
    home: "Zur Startseite",
    pending: "Zahlung wird geprüft",
    pendingSub: "Wir bestätigen Ihre Zahlung mit der Bank. Aktualisierung in wenigen Sekunden.",
    sepaPending: "Wir haben Ihre SEPA-Lastschrift registriert. Die Bank verarbeitet die Abbuchung in 1-3 Werktagen und Ihre Buchung wird automatisch per E-Mail bestätigt.",
    rate: "Tarif",
    rateFlex: "Flexibel",
    rateNonref: "Nicht erstattungsfähig (−15%)",
    helpTitle: "Stornierung oder Erstattung nötig?",
    helpWa: "Per WhatsApp schreiben",
    helpEmail: "E-Mail senden",
  },
  search: {
    results: "Verfügbarkeit",
    cta: "Suchen",
    stay: "{{nights}} Nächte · {{guests}} Gäste",
    totalStay: "Gesamtpreis",
    book: "Ansehen & buchen",
    modify: "Suche ändern",
    available: "Verfügbar",
    noneTitle: "Keine Vollverfügbarkeit",
    noneSub: "Kein Apartment ist für diese Daten und Gästezahl frei. Versuchen Sie andere Daten oder schreiben Sie uns auf WhatsApp.",
    noDates: "An diesen Daten belegt",
    altDates: "Alternative Daten für diese Wohnung",
    noCapacity: "Maximale Kapazität: {{max}} Gäste",
    unavailableTitle: "Für Ihre Suche nicht verfügbar",
    resultsFor: "Verfügbar vom {{from}} bis {{to}}",
  },
  cancel: {
    title: "Buchung abgebrochen",
    sub: "Es wurde nichts abgebucht. Sie können es jederzeit erneut versuchen.",
    back: "Zurück zur Kollektion",
  },
  amenities: {
    wifi: "Glasfaser-WLAN",
    ac: "Klimaanlage",
    kitchen: "Ausgestattete Küche",
    washer: "Waschmaschine",
    tv: "TV",
    nespresso: "Nespresso",
    linen: "Bettwäsche & Handtücher optional",
    babykit: "Babybetten & Hochstühle kostenlos auf Anfrage",
    petkit: "Hundebetten & -näpfe kostenlos auf Anfrage",
    beachview: "Freier Blick auf den Strand",
    seaview: "Teilweiser Meerblick",
    balcony: "Balkon nach Westen",
    dryer: "Föhn",
    iron: "Bügeleisen",
    patio: "Privater andalusischer Patio",
    bbq: "Mobiler Grill",
    terrace: "Private Terrasse",
    parking: "Parkplatz in der Nähe",
    bikes: "Fahrräder inklusive",
    guide: "Kuratierter Stadtführer",
    light: "Lichtdurchflutete Galerie",
    lift: "Aufzug",
  },
  whatsapp: {
    floatLabel: "Schreiben Sie uns auf WhatsApp",
    generic: "Hallo, ich interessiere mich für eines Ihrer Apartments in Cádiz.",
    booking: "Hallo, ich möchte die Verfügbarkeit von {{apartment}} prüfen ({{checkin}} → {{checkout}}).",
    successMsg: "Hallo, ich habe gerade {{apartment}} vom {{checkin}} bis {{checkout}} gebucht. Danke!",
    refund: "Hallo, ich möchte die Stornierung/Erstattung meiner Buchung bei {{apartment}} ({{checkin}} → {{checkout}}) anfragen.",
  },
  remote: {
    kicker: "Remote Work in Cádiz",
    title: "Arbeiten Sie remote mit Blick auf den Atlantik",
    text: "Glasfaser-WLAN, große helle Wohnungen und bis zu 55% Rabatt auf Langzeitaufenthalte. Mehr als einen Monat? Schreiben Sie uns – wir haben Sonderangebote für Telearbeiter.",
    cta: "Konditionen ansehen",
    waMsg: "Hallo, ich arbeite remote und interessiere mich für einen Langzeitaufenthalt (über einen Monat) in einer Ihrer Wohnungen in Cádiz. Welche Sonderangebote gibt es?",
  },
  longstay: {
    kicker: "Remote Work & Langzeitaufenthalte",
    title: "Arbeiten Sie remote mit Blick auf den Atlantik",
    sub: "Vier große, helle Wohnungen — am Strand oder in der Altstadt — mit Glasfaser-WLAN und allem, was man für eine Saison in Cádiz braucht.",
    f1t: "Glasfaser-WLAN",
    f1d: "Schnelle, stabile Verbindung für Videoanrufe und unterbrechungsfreies Arbeiten.",
    f2t: "Lichtdurchflutete Räume",
    f2d: "Große Außenwohnungen mit viel Tageslicht und bequemen Arbeitsplätzen.",
    f3t: "Automatische Rabatte",
    f3d: "−30% ab 7 Nächten, −40% ab 8 und −55% ab 16, direkt bei der Buchung angewendet.",
    f4t: "Über einen Monat",
    f4d: "Schreiben Sie uns per WhatsApp oder über das Formular – wir machen Ihnen ein Sonderangebot für Telearbeiter.",
    note: "Zeitmiete in Cádiz · Remote Work & Telearbeit am Meer · Langzeit-Sonderangebote",
  },
  instr: {
    kicker: "Fast geschafft",
    title: "Zahlung abschließen",
    loading: "Wird geladen…",
    error: "Wir finden diese Buchung nicht. Schreiben Sie uns per WhatsApp.",
    amount: "Zu zahlender Betrag",
    ref: "Referenz",
    aptLabel: "Wohnung",
    datesLabel: "Daten",
    bizumText: "Senden Sie den Betrag per Bizum an {{phone}} unter Angabe der Buchungsreferenz.",
    transferText: "Wir haben Ihnen gerade eine E-Mail mit den Bankdaten für die Überweisung gesendet. Bitte geben Sie dabei die Buchungsreferenz an.",
    paypalText: "Senden Sie den Betrag per PayPal an {{email}} unter Angabe der Buchungsreferenz.",
    warning: "Wichtig: Ihre Buchung bleibt AUSSTEHEND, bis wir Ihre Zahlung erhalten. Die Daten sind bis dahin nicht verbindlich blockiert.",
    received: "Sobald der Betrag eingeht, senden wir Ihnen die Bestätigung per E-Mail.",
    whatsapp: "Per WhatsApp Bescheid geben",
    waMsg: "Hallo, ich habe gerade die Zahlung für meine Buchung {{ref}} ({{apartment}}) gesendet.",
  },
  paypal: {
    title: "Mit PayPal zahlen",
    notCompleted: "Die Zahlung wurde nicht abgeschlossen",
    error: "Die PayPal-Zahlung konnte nicht verarbeitet werden",
    notConfigured: "PayPal wird gerade aktiviert. Schreiben Sie uns in der Zwischenzeit per WhatsApp und wir nennen Ihnen eine andere Zahlungsmethode.",
  },
  cookies: {
    text: "Wir verwenden eigene technische Cookies und Cookies von Drittanbietern (Stripe/PayPal-Zahlungen und Google Maps), damit die Website ordnungsgemäß funktioniert. Wir verfolgen oder verkaufen Ihre Daten nicht.",
    accept: "Akzeptieren",
    reject: "Ablehnen",
    more: "Mehr Informationen",
  },
  rules: {
    title: "Hausregeln",
    r1: "Check-in: 15 Uhr · Check-out: 12 Uhr",
    r2: "Keine Geräusche ab 22 Uhr",
    r3: "Rauchen in der Wohnung, im Treppenhaus und auf den Patios verboten",
    r4: "Kaution von 300 € pro Woche: wird beim Check-in mit derselben Zahlungsmethode erhoben, nach gemeinsamer Prüfung des Zustands, und beim Check-out nach erneuter Prüfung zurückgegeben. Falls etwas nicht dem ausgehändigten Zustandsbericht entspricht, melden Sie es bitte innerhalb von 12 Stunden nach Ankunft.",
    r5: "Soweit möglich, berücksichtigen wir die Bedürfnisse jedes Gastes.",
  },
  legal: {
    notice: "Impressum",
    privacy: "Datenschutz",
    cookies: "Cookies",
    cancel: "Stornierungsrichtlinie",
    terms: "Aufenthaltsbedingungen",
  },
  checkin: {
    kicker: "Online-Check-in",
    notFound: "Wir finden diese Buchung nicht",
    backHome: "Zurück zur Website",
    doneTitle: "Check-in abgeschlossen",
    doneText: "Gäste registriert, Zustand der Wohnung unterschrieben und Kaution hinterlegt. Wir erwarten dich am {{date}} ab 15:00 Uhr.",
    summary: "{{checkin}} → {{checkout}} · {{nights}} Nächte · {{guests}} Gäste",
    step1: "1 · Daten aller Mitreisenden",
    step1Note: "Vom spanischen Melderegister für Reisende vorgeschrieben. Bitte trage die Daten jeder Person ein, die übernachtet.",
    occupant: "Person {{n}}",
    remove: "Entfernen",
    firstName: "Vorname *",
    lastName: "Nachname *",
    docId: "Ausweis / Reisepass *",
    birthdate: "Geburtsdatum",
    nationality: "Staatsangehörigkeit",
    address: "Wohnadresse",
    addOccupant: "Person hinzufügen",
    step2: "2 · Zustand der Wohnung",
    stateIntro: "Die Wohnung wird in einwandfreiem Zustand und mit dem gesamten Haushaltsinventar übergeben. Ich verpflichte mich, sie bei der Ankunft zu überprüfen.",
    stateDeadline: "Ich habe 24 Stunden ab der Ankunft",
    stateRest: ", um eventuelle Mängel zu melden. Nach Ablauf dieser Frist können festgestellte Schäden oder fehlende Gegenstände von der Kaution abgezogen werden. Mit meiner Unterschrift akzeptiere ich diese Bedingungen.",
    signReady: "Unterschrift fertig",
    signHint: "Zeichne deine Unterschrift mit dem Finger oder der Maus",
    signClear: "Löschen",
    step3: "3 · Kaution ({{amount}} €)",
    depositText1: "{{perWeek}} € pro Woche. ",
    depositBold: "Sie wird nur auf deiner Karte reserviert, nicht belastet.",
    depositText2: " Sie wird nach der Abnahme bei der Abreise automatisch freigegeben, wenn alles in Ordnung ist.",
    depositOk: "Kaution erfolgreich reserviert (es wurde nichts belastet)",
    depositRedirect: "Weiterleitung…",
    depositBtn: "Kaution von {{amount}} € reservieren",
    submit: "Daten und Unterschrift senden",
    submitting: "Wird gesendet…",
    submitted: "Daten und Unterschrift gesendet ✓",
    help: "Fragen: WhatsApp +34 667 39 67 67",
    errMissing: "Bitte mindestens Vorname, Nachname und Ausweis jeder Person ausfüllen",
    errSignature: "Deine Unterschrift zum Zustand der Wohnung fehlt",
    okSubmitted: "Check-in erfolgreich registriert",
    errSubmit: "Der Check-in konnte nicht gesendet werden",
    errDeposit: "Die Kautionsreservierung konnte nicht gestartet werden",
  },
  reviews: {
    kicker: "Was unsere Gäste sagen",
    title: "Bewertungen",
    sub: "Echte Erfahrungen in unseren Häusern in Cádiz.",
  },
};
